import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BookingReasonState } from './booking-reason.state';

const selectBookingReasonSelector = createFeatureSelector<BookingReasonState>('bookingReason');

export const selectBookingReasonState = createSelector(
  selectBookingReasonSelector,
  state => state.bookingReason
);
